import React, { FC, useEffect } from 'react';

import { LoaderVersionValues } from '../../services/growthbook/features';
import { SpinnerFullscreenLoader } from './versions/spinner';
import { DancerFullscreenLoader } from './versions/dancer';
import { checkIsComplianceMode } from '../../middlewares/app-mode/helpers';
import { randomizer } from '../../utils/randomizer';
import { useLocalStorage } from '../../hooks';
import analytics from '../../services/analytics';

const LOADER_VERSION_KEY = 'loader_version';

const FullscreenLoader: FC = () => {
  const [version, setVersion] = useLocalStorage<LoaderVersionValues | null>(LOADER_VERSION_KEY, null);

  useEffect(() => {
    if (!version) {
      const randomValue = randomizer() ? LoaderVersionValues.V1 : LoaderVersionValues.V2;
      setVersion(randomValue);
      analytics.setUserProperties({ loader_version: randomValue });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [version]);

  const LoaderComponent =
    checkIsComplianceMode() || version === LoaderVersionValues.V1 ? SpinnerFullscreenLoader : DancerFullscreenLoader;

  return <LoaderComponent />;
};

export default FullscreenLoader;
